module.exports = __webpack_public_path__ + "static/assets/f572627b3caef731a440613e133041b2.png";